import {createDecorator} from "vue-class-component"
import Vue, {ComponentOptions} from "vue"

type InjectOptions = { from: string; default?: any }

/**
 * https://github.com/vuejs/vue/issues/7017#issuecomment-480906691
 *
 * This works by making a placeholder computed property, and then passing that computed property down through the
 * usual vue provide/inject system. Then on the other end, we execute the computed property.
 *
 */

interface ExtendedComponentOptions extends ComponentOptions<Vue> {
    jdsProvide?: Array<string>
}

export function ActiveProvide(key: string) {
    return createDecorator((componentOptions: ExtendedComponentOptions, k) => {
        if (typeof componentOptions.computed === 'undefined') {
            componentOptions.computed = {}
        }
        // todo: support for a provide array (just append it to the function)
        // todo: support for regular Provides
        if (typeof componentOptions.provide === 'function' && Array.isArray(componentOptions.jdsProvide)) {
            // if there's already a provide function, we'll chain a new one to it.
            componentOptions.jdsProvide.push(key);
            componentOptions.provide = function() {
                return Object.fromEntries((componentOptions.jdsProvide as Array<string>).map(k => {
                    return [k, () => (this as any)['i_'+k]];
                }))
            }
        } else {
            // if there's no provide function yet, we'll just set it.
            componentOptions.jdsProvide = [key];
            componentOptions.provide = function() {
                return {[key]: () => (this as any)['i_'+key]}
            }
        }
        componentOptions.computed['i_'+key] = function () {
            return this[k];
        }
    })
}

export function ActiveInject(options: InjectOptions) {
    return createDecorator((componentOptions, key) => {
        if (typeof componentOptions.inject === 'undefined') {
            componentOptions.inject = {}
        }
        if (typeof componentOptions.computed === 'undefined') {
            componentOptions.computed = {}
        }
        (componentOptions.inject as any)['i_'+options.from] = {
            from: options.from, default () {
                return () => options.default;
            }
        };
        componentOptions.computed[key] = function () {
            return (this['i_'+options.from] as ()=>any)();
        }
    })
}
